import { useContext, useEffect } from 'react';
import AppContext from './../contexts/AppContext';
import DataContext from '../contexts/DataContext';
import ConfigContext from '../contexts/ConfigContext';
import icon from './../images/icon-click-to-call.svg';
import { appendScript, isMobile } from '../helpers';

export default function ClickToAction() {
  const { clickedCallASpecialist, setClickedCallASpecialist, slfApiUrl, lsid, urlParams } =
    useContext(AppContext);
  const { data } = useContext(DataContext);
  const { testName } = useContext(ConfigContext);

  /*
  // Keeping this code as reference in case we need to set afterHours according to a specific timezone
  const isDaylightSavingTime = (date: Date) => {
    const january = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
    const july = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
    return date.getTimezoneOffset() < Math.max(january, july);
  };

  const currentDate = new Date();
  const timezoneOffset = currentDate.getTimezoneOffset();
  const pstOffset = isDaylightSavingTime(currentDate) ? -420 : -480; // Offset for the Pacific Standard Time timezone
  const currentPSTDate = new Date(
    currentDate.getTime() + (pstOffset + timezoneOffset) * 60 * 1000
  );

  const currentHour = currentPSTDate.getHours();
  const currentDay = currentPSTDate.getDay();
  */

  const currentDate = new Date();
  const currentHour = currentDate.getHours();
  const currentDay = currentDate.getDay();

  useEffect(() => {
    const interval = setInterval(() => {
      if (sessionStorage.getItem("callPopupClosed") === "true") {
        const phoneLink = document.querySelector('a[href="tel:+15109456752"]');
        if (phoneLink && phoneLink instanceof HTMLAnchorElement) {
          phoneLink.click();
        }
        sessionStorage.removeItem("callPopupClosed");
        // clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const isAfterHours =
    currentDay === 0 ||
    currentDay === 6 ||
    currentHour < 8 ||
    currentHour >= 21;

  return (
    <div className="flex mr-[24px] md:mr-20 items-center">
      {!isAfterHours && (
        <a
          href="tel:+15109456752"
          target="_blank"
          className="ml-2 md:ml-3 flex items-center text-black text-[14px] bg-enph-orange px-[14px] py-[7px] rounded-full hover:opacity-80"
          onClick={() => {
            if (window.leadId) {
              const updateuserMetaUrl = `${slfApiUrl}/api/user/update_lead_meta/${window.leadId}/clicked_call_a_specialist/1`;
              appendScript(updateuserMetaUrl);
            } else {
              setClickedCallASpecialist(true);
              try {
                if (clickedCallASpecialist) return;
                (async () => {
                  const requestData: any = {
                    country: 'US',
                    street: data.selectedAddress,
                    city: data.selectedCity,
                    state: data.selectedState?.toUpperCase(),
                    zip: data.selectedZipCode,
                    phone_number: '',
                    human_check: '',
                    xxTrustedFormToken: (
                      document.getElementById('xxTrustedFormToken_0') as any
                    )?.value,
                    xxTrustedFormCertUrl: (
                      document.getElementById('xxTrustedFormCertUrl_0') as any
                    )?.value,
                    xxTrustedFormPingUrl: (
                      document.getElementById('xxTrustedFormPingUrl_0') as any
                    )?.value,
                    lsid: lsid,
                    f: testName !== 'default' ? 'ab_test_' + testName : null,
                    'meta:enphase_branded': 1,
                  };

                  if (requestData.first_name === 'passQC') {
                    requestData.zip = 99999;
                  }

                  const formData = new FormData();
                  for (let key in requestData) {
                    formData.append(key, requestData[key]);
                  }

                  const postUrl = `${slfApiUrl}/signup/partial${urlParams}${
                    testName !== 'default' ? '&f=ab_test_' + testName : ''
                  }`;

                  const leadResponse = await fetch(postUrl, {
                    method: 'POST',
                    body: formData,
                  });
                  // Dev server returns a html response with warnings, so instead of reading the json response we get the text
                  const resultText = await leadResponse.text();
                  let result: any = {};
                  try {
                    result = JSON.parse(resultText);
                  } catch (e) {
                    const jsonMatches = resultText.match(/{".+"}/g);
                    if (jsonMatches) result = JSON.parse(jsonMatches[0]);
                  }
                })();
              } catch (e) {}
            }
          }}>
          <img alt="" src={icon} className="mr-2" />
          <span className={isMobile() ? '' : 'mt-1'}>(510) 945-6752</span>
        </a>
      )}
    </div>
  );
}
